import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataAPtype,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent shortcuts when typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') {
        return;
      }
      
      // ESC key - Cancel/Back
      if (event.key === 'Escape') {
        event.preventDefault();
        if (window.confirm('ต้องการยกเลิกการทำงานหรือไม่?')) {
          window.location.href = "/tbsettranstype";
        }
      }
      
      // F10 key - Save
      if (event.key === 'F10') {
        event.preventDefault();
        if (mode === 'I') return;
        if (mode === 'U') {
          confirmAndUpdate();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        Trans_TypeID: 0,
        Trans_TypeName: "",
        Trans_Status: "Y",
      };
      // กำหนดค่าเริ่มต้นให้กับ form data
      setFormData(initialData);
      // กำหนดค่าเริ่มต้นให้กับ initial form data
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        Trans_TypeID: selectedData.Trans_TypeID,
        Trans_TypeName: selectedData.Trans_TypeName,
        Trans_Status: selectedData.Trans_Status,
      };
      // อัปเดตค่าให้กับ form data
      setFormData(initialData);
      // อัปเดตค่าให้กับ initial form data
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  // ฟังก์ชันที่ใช้ในการเปลี่ยนค่าของข้อมูลในฟอร์ม
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleInsertAP = async () => {
    try {
      const { Trans_TypeID, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_TransType", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error in handleInsertAP:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const formatValues = (data) => {
    const { Trans_TypeID, ...rest } = data;
    return rest;
  };

  const handleUpdateAP = async () => {
    try {
      const where = { Trans_TypeID: formData.Trans_TypeID }; // ส่งในรูปแบบ Object
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_TransType", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_TransType",
            `WHERE Trans_TypeID = ${selectedData.Trans_TypeID}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const confirmAndSubmit = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการบันทึกข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleSubmit();
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const confirmAndUpdate = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการแก้ไขข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleUpdateAP();
          await callInitialize();
          window.location.href = "/transType";
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    try {
      //   if (
      //     !formData.ap_code ||
      //     !formData.ap_name ||
      //     !formData.ap_type ||
      //     !formData.ap_status
      //   ) {
      //     getAlert(
      //       "WARNING",
      //       "โปรดกรอกข้อมูล รหัสเจ้าหนี้ ชื่อเจ้าหนี้  ประเภทเจ้าหนี้  สถานะ"
      //     );
      //     return;
      //   }
      // ตรวจสอบว่าข้อมูลที่แก้ไขว่าซ้ำกับข้อมูลเดิมหรือไม่
      //   if (
      //     formData.ap_code === initialFormData.ap_code &&
      //     formData.ap_name === initialFormData.ap_name
      //   ) {
      //     getAlert(
      //       "WARNING",
      //       "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      //     );
      //     return;
      //   }
      if (mode === "I") {
        await handleInsertAP();
      } else if (mode === "U") {
        await handleUpdateAP();
      }
      await callInitialize();
      setFormData({
        Trans_TypeID: 0,
        Trans_TypeName: "",
        Trans_Status: "Y",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/transType" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="mb-3 border-bottom pb-2">วิธีการขนส่ง</h5>
            <div className="row g-3">
              <div className="col-6">
                <label>วิธีการขนส่ง</label>
                <input type="text" className="form-control" name="Trans_TypeName" value={formData.Trans_TypeName || ""} onChange={handleChange} />
              </div>
              <div className="col-6">
                <label>สถานะ</label>
                <select className="form-select" name="Trans_Status" value={formData.Trans_Status || "Y"} onChange={handleChange}>
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>

            <div className="row mt-4">
              {mode !== "I" ? (
                <div className="d-flex justify-content-between align-items-center">
                  <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                  <div className="d-flex gap-2">
                    <button onClick={() => (window.location.href = "/transType")} type="button" className="btn btn-dark btn-lg">ยกเลิก</button>
                    <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก</button>
                  </div>
                </div>
              ) : (
                <div className="d-flex">
                  <FormAction onSubmit={handleSubmit} onUpdate={handleSubmit} onDelete={handleDelete} mode={mode} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
